module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BF-a4f8eb7a857dbbe3a84f2a99ebf17fa9.png";